import React, {memo} from 'react';
import Cross from './Cross';

export default memo(function ModalHeading({ title, close }) {
    return <div className="titleBar">
        <div className="title"><h3>{title}</h3></div>
        <Cross close={close}/>
    </div>
})